var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2136_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 12.6654C11.4724 12.6654 12.6663 11.4715 12.6663 9.9987C12.6663 8.52594 11.4724 7.33203 9.99967 7.33203C8.52691 7.33203 7.33301 8.52594 7.33301 9.9987C7.33301 11.4715 8.52691 12.6654 9.99967 12.6654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 1.66797L5.97533 3.33464H3.33366C2.41699 3.33464 1.66699 4.08464 1.66699 5.0013V15.0013C1.66699 15.918 2.41699 16.668 3.33366 16.668H16.667C17.5837 16.668 18.3337 15.918 18.3337 15.0013V5.0013C18.3337 4.08464 17.5837 3.33464 16.667 3.33464H14.0253L12.5003 1.66797H7.50033ZM10.0003 14.168C7.70033 14.168 5.83366 12.3013 5.83366 10.0013C5.83366 7.7013 7.70033 5.83464 10.0003 5.83464C12.3003 5.83464 14.167 7.7013 14.167 10.0013C14.167 12.3013 12.3003 14.168 10.0003 14.168Z",
    fill: "#313133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2136_742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.0655a152ed06b1d6b6a9aed1aadd5928.svg";
export { ForwardRef as ReactComponent };